<mat-list class="alert alert-success mt-3" *ngIf="message && message != ''">
    <h1 class="mt-3"><mat-icon aria-hidden="false" aria-label="Menu dropdown" class="">check_circle</mat-icon> Success</h1>
    <p>{{ message }}</p>
</mat-list>
